const defaultParams = {
    page: 0,
    size: 20
};

export default class UsersApi {
    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(UsersApi.UsersPath);
    }

    getPagedUsers(params) {
        var normParams = Object.assign({}, defaultParams, params);
        return this.DashAPI.CORE.get(UsersApi.UsersPath, normParams);
    }

    getUserById(userId) {
        return this.DashAPI.CORE.get(UsersApi.UsersPath + '/' + userId);
    }

    updateUser(user) {
        return this.DashAPI.CORE.put(UsersApi.UsersPath + '/' + user.id, user);
    }
}

UsersApi.UsersPath = '/api/users';



// WEBPACK FOOTER //
// ./src/DashApi/users/UsersApi.js


// WEBPACK FOOTER //
// webpack:///src/DashApi/users/UsersApi.js